import { render, staticRenderFns } from "./PracticalMatterList.vue?vue&type=template&id=66929c7e"
import script from "./PracticalMatterList.vue?vue&type=script&lang=js"
export * from "./PracticalMatterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports